export const institutionKeys = {
  all: ["institutions"] as const,
  lists: () => [...institutionKeys.all, "list"] as const,
  list: (trashOnly: boolean) => [...institutionKeys.lists(), { trashOnly }] as const,
  detail: (id: string) => [...institutionKeys.all, "detail", id] as const,
  // Prefix: a school's calendar change can flip any institution's
  // "calendar configured" health line (PRD-61 FR-1.6).
  healths: () => [...institutionKeys.all, "health"] as const,
  health: (id: string) => [...institutionKeys.healths(), id] as const,
  // PRD-61 FR-1.5 — one institution's evaluation calendar for one school
  // year; `null` is "the year in course", which the API resolves.
  calendarsFor: (id: string) => [...institutionKeys.all, "calendar", id] as const,
  calendar: (id: string, schoolYear: string | null) =>
    [...institutionKeys.calendarsFor(id), schoolYear ?? "current"] as const,
}
